export default __webpack_public_path__ + "static/media/indigita_logo_AMT.b12d6567.svg";